<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 2438 2170"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs></defs>
    <g fill-rule="nonzero" fill="none">
      <path
        d="M529.28 2060.4 29.34 1194.447c-39.12-67.76-39.12-151.243 0-219.002L529.28 109.51C568.409 41.74 640.72 0 718.973 0h999.88c78.247 0 150.55 41.747 189.673 109.51l499.94 865.935c39.128 67.764 39.128 151.257 0 219.021l-499.94 865.934c-39.128 67.757-111.43 109.492-189.673 109.492h-999.88c-78.254 0-150.567-41.738-189.691-109.51v.018Z"
        fill="#4487FB"
      />
      <path
        d="M2241.428 1481.378 1535.541 777.83l-316.629-84.732-284.404 105.701-109.834 286.157 88.313 318.609 776.11 766.327c56.22-2.97 106.36-15.198 150.422-36.684 39.271-31.581 173.241-248.858 401.91-651.83Z"
        fill="#000"
        opacity=".07"
      />
      <g fill="#FFF">
        <path
          d="M1218.912 643.18c-243.97 0-441.756 197.786-441.756 441.776 0 243.97 197.786 441.756 441.756 441.756 243.971 0 441.738-197.786 441.738-441.756 0-243.99-197.786-441.776-441.738-441.776m0 776.954c-185.12 0-335.198-150.077-335.198-335.197 0-185.121 150.078-335.18 335.198-335.18 185.121 0 335.198 150.078 335.198 335.199 0 185.12-150.077 335.197-335.198 335.197"
        />
        <path
          d="M1009.223 1067.89v137.318a243.666 243.666 0 0 0 83.419 85.228V1067.89h-83.419Zm165.409-115.757v369.69c14.189 2.609 28.701 4.19 43.614 4.19 13.598 0 26.854-1.43 39.862-3.6v-370.28h-83.476Zm173.141 172.818v163.066a243.514 243.514 0 0 0 83.457-89.513v-73.534l-83.457-.02Zm189.025 232.105-45.766 45.804c-8.071 8.089-8.071 21.184 0 29.273l173.598 173.541c8.089 8.071 21.184 8.071 29.273 0l45.766-45.747c8.017-8.103 8.017-21.15 0-29.254l-173.617-173.617c-8.095-8.037-21.16-8.037-29.254 0"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import VueTypes from 'vue-types';
export default {
  name: 'BigQueryLogoIcon',
  props: {
    height: VueTypes.string.def('32'),
    width: VueTypes.string.def('32'),
  },
};
</script>

<style lang="scss"></style>
